import { apiClient } from '../axios-instance'
import type { AxiosResponse } from 'axios'

export interface DashboardMetrics {
  revenue: {
    today: number
    this_week: number
    this_month: number
    this_year: number
    growth_percentage: number
  }
  orders: {
    total: number
    today: number
    this_week: number
    this_month: number
    this_year: number
    pending: number
    completed: number
    cancelled: number
    growth_percentage: number
  }
  users: {
    total: number
    active: number
    new_this_month: number
    growth_percentage: number
  }
  merchants: {
    total: number
    active: number
    pending_verification: number
  }
  products: {
    total: number
    pending_approval: number
    out_of_stock: number
  }
}

export interface RevenueAnalytics {
  period: string
  data: {
    date: string
    revenue: number
    orders: number
  }[]
}

export interface UserAnalytics {
  period: string
  data: {
    date: string
    new_users: number
    active_users: number
  }[]
}

/**
 * Real-time system status.
 * All 16 microservices stream metrics to the central bid_analytics DB.
 */
export interface SystemStatus {
  avg_response_time_ms: number
  active_sessions: number
  queue_jobs: number
  exception_count: number
  online_services: number
  total_services: number
  api_uptime_percent: number
  window_minutes: number
  recorded_at: string
}

export const analyticsService = {
  getDashboardMetrics: async (): Promise<DashboardMetrics> => {
    const response: AxiosResponse<{ success: boolean; data: DashboardMetrics }> =
      await apiClient.get('/analytics/dashboard')
    return response.data.data
  },

  getSystemStatus: async (): Promise<any> => {
    const response = await apiClient.get('/health/summary')
    return response.data
  },


  getRevenueAnalytics: async (period: 'day' | 'week' | 'month' | 'year'): Promise<RevenueAnalytics> => {
    const response: AxiosResponse<{ success: boolean; data: RevenueAnalytics }> =
      await apiClient.get('/analytics/revenue', { params: { period } })
    return response.data.data
  },

  getUserAnalytics: async (period: 'day' | 'week' | 'month' | 'year'): Promise<UserAnalytics> => {
    const response: AxiosResponse<{ success: boolean; data: UserAnalytics }> =
      await apiClient.get('/analytics/users', { params: { period } })
    return response.data.data
  },

  getProductAnalytics: async (): Promise<any> => {
    const response = await apiClient.get('/analytics/products')
    return response.data.data
  },

  getMerchantAnalytics: async (): Promise<any> => {
    const response = await apiClient.get('/analytics/merchants')
    return response.data.data
  },
}
